import 'ol/ol.css';
import {apply} from 'ol-mapbox-style';

apply('map', 'data/geojson.json');
